"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StepperNavigationLocationEnum = exports.StepperNavigation = exports.BaseLookup = exports.QuestionnaireView = exports.OffenseInformationCard = exports.IndividualDetailsCard = exports.IndividualDetailEdit = exports.IndividualDetailReview = exports.ComponentStepper = exports.FeatureFlagView = exports.NewIndividual = exports.LookupSelect = exports.ProgressCircle = exports.Toast = void 0;
exports.initalizeSupervisionCore = initalizeSupervisionCore;
const forge_1 = require("@tylertech/forge");
const forge_extended_1 = require("@tylertech/forge-extended");
const tyler_icons_1 = require("@tylertech/tyler-icons");
function initalizeSupervisionCore() {
    console.info('Initializing Supervision Core');
    (0, forge_1.defineComponents)();
    // forge-extended has no bulk define function, so each component is registered individually
    (0, forge_extended_1.defineAppLauncherComponent)();
    (0, forge_extended_1.defineAppLauncherLinkComponent)();
    (0, forge_extended_1.defineAppLayoutComponent)();
    (0, forge_extended_1.defineBusyIndicatorComponent)();
    (0, forge_extended_1.defineConfirmationDialogComponent)();
    (0, forge_extended_1.defineContentScaffoldComponent)();
    (0, forge_extended_1.defineCountCardComponent)();
    (0, forge_extended_1.defineFooterComponent)();
    (0, forge_extended_1.defineFooterItemComponent)();
    (0, forge_extended_1.defineMultiSelectHeaderComponent)();
    (0, forge_extended_1.defineProfileLinkComponent)();
    (0, forge_extended_1.defineQuantityFieldComponent)();
    (0, forge_extended_1.defineResponsiveToolbarComponent)();
    (0, forge_extended_1.defineStructuredCardComponent)();
    (0, forge_extended_1.defineThemeToggleComponent)();
    (0, forge_extended_1.defineUserProfileComponent)();
    forge_1.IconRegistry.define([
        tyler_icons_1.tylIconAddCircle,
        tyler_icons_1.tylIconBatteryFull,
        tyler_icons_1.tylIconBatteryOutline,
        tyler_icons_1.tylIconBattery20,
        tyler_icons_1.tylIconBattery40,
        tyler_icons_1.tylIconBattery60,
        tyler_icons_1.tylIconBattery80,
        tyler_icons_1.tylIconCircle,
        tyler_icons_1.tylIconCheckCircle,
        tyler_icons_1.tylIconDeleteCircle,
        tyler_icons_1.tylIconBatteryAlert,
        tyler_icons_1.tylIconCloseCircle,
        tyler_icons_1.tylIconPulse,
        tyler_icons_1.tylIconLocationOn,
        tyler_icons_1.tylIconVolumeHigh,
        tyler_icons_1.tylIconVolumeLow,
        tyler_icons_1.tylIconVibrate,
        tyler_icons_1.tylIconAddLocationAlt,
        tyler_icons_1.tylIconFileDocumentMultiple,
        tyler_icons_1.tylIconCall,
        tyler_icons_1.tylIconPhonelinkRing,
        tyler_icons_1.tylIconLockOpen,
        tyler_icons_1.tylIconLockOutline,
        tyler_icons_1.tylIconNote,
        tyler_icons_1.tylIconNotePlus,
        tyler_icons_1.tylIconWarning,
        tyler_icons_1.tylIconCalendarMonth,
        tyler_icons_1.tylIconEdit,
        tyler_icons_1.tylIconChevronDown,
        tyler_icons_1.tylIconChevronUp,
        tyler_icons_1.tylIconClockOutline,
        tyler_icons_1.tylIconDirections,
        tyler_icons_1.tylIconEarth,
        tyler_icons_1.tylIconVisibilityOff,
        tyler_icons_1.tylIconLinearScale,
        tyler_icons_1.tylIconShare,
        tyler_icons_1.tylIconPlayCircleOutline,
        tyler_icons_1.tylIconPauseCircleOutline,
        tyler_icons_1.tylIconSkipNextCircleOutline,
        tyler_icons_1.tylIconSkipPreviousCircleOutline,
        tyler_icons_1.tylIconFastForward,
        tyler_icons_1.tylIconFastRewind,
        tyler_icons_1.tylIconInfo,
        tyler_icons_1.tylIconListStatus,
        tyler_icons_1.tylIconFileExcelOutline,
        tyler_icons_1.tylIconBatteryUnknown,
        tyler_icons_1.tylIconSatelliteVariant,
        tyler_icons_1.tylIconCompass,
        tyler_icons_1.tylIconVuetify,
        tyler_icons_1.tylIconPerson,
        tyler_icons_1.tylIconTableView,
        tyler_icons_1.tylIconArrowRight,
        tyler_icons_1.tylIconArrowLeft,
        tyler_icons_1.tylIconArrowBack,
        tyler_icons_1.tylIconSquareEditOutline,
        tyler_icons_1.tylIconContentSaveOutline,
        tyler_icons_1.tylIconFilterVariant,
        tyler_icons_1.tylIconInformationOutline,
        tyler_icons_1.tylIconHome,
        tyler_icons_1.tylIconFilePdfBox,
        tyler_icons_1.tylIconHelp,
        tyler_icons_1.tylIconVolumeOff,
        tyler_icons_1.tylIconCancel,
        tyler_icons_1.tylIconPersonOutline,
        tyler_icons_1.tylIconInfoOutline,
        tyler_icons_1.tylIconCalendarClockOutline,
        tyler_icons_1.tylIconCalendarRemove,
        tyler_icons_1.tylIconPoliceBadgeOutline,
        tyler_icons_1.tylIconBank,
        tyler_icons_1.tylIconBellOutline,
        tyler_icons_1.tylIconCameraOutline,
        tyler_icons_1.tylIconBackspaceOutline,
        tyler_icons_1.tylIconLogin,
        tyler_icons_1.tylIconLogout,
        tyler_icons_1.tylIconRefresh,
        tyler_icons_1.tylIconAlertCircleOutline,
        tyler_icons_1.tylIconShieldAlertOutline
    ]);
}
// Components
var toast_1 = require("./src/components/toast/toast");
Object.defineProperty(exports, "Toast", { enumerable: true, get: function () { return toast_1.Toast; } });
var progress_circle_1 = require("./src/components/progress-circle/progress-circle");
Object.defineProperty(exports, "ProgressCircle", { enumerable: true, get: function () { return progress_circle_1.ProgressCircle; } });
var lookup_select_1 = require("./src/components/lookup/select/lookup-select");
Object.defineProperty(exports, "LookupSelect", { enumerable: true, get: function () { return lookup_select_1.LookupSelect; } });
var new_individual_1 = require("./src/components/new-individual/new-individual");
Object.defineProperty(exports, "NewIndividual", { enumerable: true, get: function () { return new_individual_1.NewIndividual; } });
var feature_flag_view_1 = require("./src/components/feature-flag-view/feature-flag-view");
Object.defineProperty(exports, "FeatureFlagView", { enumerable: true, get: function () { return feature_flag_view_1.FeatureFlagView; } });
var component_stepper_1 = require("./src/components/stepper/component-stepper");
Object.defineProperty(exports, "ComponentStepper", { enumerable: true, get: function () { return component_stepper_1.ComponentStepper; } });
var individual_detail_review_1 = require("./src/components/individual-detail/individual-detail-review");
Object.defineProperty(exports, "IndividualDetailReview", { enumerable: true, get: function () { return individual_detail_review_1.IndividualDetailReview; } });
var individual_detail_edit_1 = require("./src/components/individual-detail/individual-detail-edit");
Object.defineProperty(exports, "IndividualDetailEdit", { enumerable: true, get: function () { return individual_detail_edit_1.IndividualDetailEdit; } });
// Card / View
var individual_details_card_1 = require("./src/components/cards/individual-details-card/individual-details-card");
Object.defineProperty(exports, "IndividualDetailsCard", { enumerable: true, get: function () { return individual_details_card_1.IndividualDetailsCard; } });
var offense_information_card_1 = require("./src/components/cards/offense-information-card/offense-information-card");
Object.defineProperty(exports, "OffenseInformationCard", { enumerable: true, get: function () { return offense_information_card_1.OffenseInformationCard; } });
// Views
var questionnaire_view_1 = require("./src/domain/segment/questionnaire/questionnaire.view");
Object.defineProperty(exports, "QuestionnaireView", { enumerable: true, get: function () { return questionnaire_view_1.QuestionnaireView; } });
// Data Objects
var base_lookup_1 = require("./src/domain/entities/lookup/base-lookup");
Object.defineProperty(exports, "BaseLookup", { enumerable: true, get: function () { return base_lookup_1.BaseLookup; } });
// Navigations / Views
var stepper_navigation_1 = require("./src/components/navigation/stepper-navigation");
Object.defineProperty(exports, "StepperNavigation", { enumerable: true, get: function () { return stepper_navigation_1.StepperNavigation; } });
var stepper_navigation_location_enum_1 = require("./src/components/navigation/stepper-navigation-location.enum");
Object.defineProperty(exports, "StepperNavigationLocationEnum", { enumerable: true, get: function () { return stepper_navigation_location_enum_1.StepperNavigationLocationEnum; } });
initalizeSupervisionCore();
